<template>
  <div>
    <Subheader id="search-tile" :title="searchTitle" />

    <div class="app-content-column">
      <div v-if="!showSearchTile" style="text-align: center">
        <h5 style="margin-top: 1.25rem" @click="clearSearch">Clear Search Results</h5>
      </div>
      <div v-if="showSearchTile">
        <div class="card">
          <p>Search, sort, and filter for projects you'd like to follow and help fund!</p>
          <h5>Search</h5>
          <div class="form">
            <input
              v-model="projectFilter.search"
              placeholder="e.g. Project Name"
              class="input"
              type="text"
              @change="refreshData()"
            />
            <div class="search-button-wrapper">
              <button class="search-button">Search</button>
            </div>
          </div>
          <!-- NRS 10.24.2019 -- These are not working currently, commenting them out until we fix the back end. -->
          <!-- <h5>
          Sort
        </h5>
        <div class="search-button-wrapper-container">
          <div class="search-button-wrapper">
            <button
              class="filter-button"
              :class="{ 'filter-button--selected': projectFilter.ordering === 'goal_ending_soon' }"
              @click="updateProjectOrderingFilter('goal_ending_soon')"
            >
              Ending Soon
            </button>
            <button
              class="filter-button"
              :class="{ 'filter-button--selected': projectFilter.ordering === 'goal_almost_met' }"
              @click="updateProjectOrderingFilter('goal_almost_met')"
            >
              Close to Goal
            </button>
            <button
              class="filter-button"
              :class="{ 'filter-button--selected': projectFilter.ordering === 'datetime_created' }"
              @click="updateProjectOrderingFilter('datetime_created')"
            >
              Recently Posted
            </button>
          </div>
          </div>-->
          <h5>Filter</h5>
          <div class="search-button-wrapper">
            <button
              class="filter-button"
              :class="{ 'filter-button--selected': showLocation }"
              @click="toggleLocations"
            >
              Location
            </button>
            <button
              class="filter-button"
              :class="{ 'filter-button--selected': showInterest }"
              @click="toggleInterests"
            >
              Interests
            </button>
          </div>
        </div>
        <div v-if="showLocation" class="card">
          <h5>Filter by Location</h5>
          <div class="search-button-wrapper">
            <button
              v-for="attribute in locationAttributes"
              :key="attribute.id"
              class="filter-button"
              :class="{
                'filter-button--selected': projectFilter.attributes.includes(attribute.id),
              }"
              @click="updateProjectAttributeFilter(attribute.id)"
            >
              {{ attribute.name }}
            </button>
          </div>
        </div>
        <div v-if="showInterest" class="card">
          <h5>Filter by Interest Area</h5>
          <div class="search-button-wrapper">
            <button
              v-for="attribute in interestAttributes"
              :key="attribute.id"
              class="filter-button"
              :class="{
                'filter-button--selected': projectFilter.attributes.includes(attribute.id),
              }"
              @click="updateProjectAttributeFilter(attribute.id)"
            >
              {{ attribute.name }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="!dataLoaded" class="container">Loading...</div>
      <div v-if="dataLoaded">
        <Pagination
          :pagination-details="paginationDetails"
          :show-only-result-count="false"
          :hide-pages="true"
          @update="refreshData($event)"
        />
        <div v-if="projects.length === 0">
          <div class="card">
            <span>No Projects Found</span>
          </div>
        </div>
        <div v-for="project in projects" :key="project.id" class="projects">
          <ProjectCard :project="project" />
        </div>
        <Pagination
          :pagination-details="paginationDetails"
          :show-only-result-count="false"
          :hide-pages="true"
          @update="refreshData($event)"
        />
      </div>
      <div v-if="dataLoaded && showSearchTile && projects.length > 1">
        <div class="scroll-button" @click="scrollToTop">Return to Top</div>
      </div>
    </div>
  </div>
</template>

<script>
/*global fbq*/
import Subheader from '@/components/Subheader'
import ProjectCard from '@/components/ProjectCard'

import Project from '@/services/projects'
import Attribute from '@/services/attributes'

import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/utils/pagination'

import { buttons } from '@/services/utils/homeButtons'

export default {
  name: 'SearchProjects',
  components: {
    Subheader,
    ProjectCard,
    Pagination,
  },
  data() {
    return {
      showLocation: false,
      showInterest: false,
      projectFilter: {
        ordering: '',
        search: '',
        attributes: [],
      },
      paginationDetails: {},
      attributeLocationFilter: {
        group: 'Interest',
      },
      attributeInterestFilter: {},
      projects: [],
      attributes: [],
      dataLoaded: false,
      buttons: buttons,
      searchTitle: 'Browse All',
      showSearchTile: true,
    }
  },
  computed: {
    locationAttributes() {
      if (this.attributes.length === 0) return []
      return this.attributes.filter(a => a.group === 'Location')
    },
    interestAttributes() {
      if (this.attributes.length === 0) return []
      return this.attributes.filter(a => a.group === 'Interest Area')
    },
  },
  created() {
    if (this.$route.params.buttonId) {
      const buttonId = this.$route.params.buttonId
      let button = this.buttons.find(button => button.id == buttonId)
      this.projectFilter.attributes = button.tags
      this.searchTitle = button.text
      this.showSearchTile = false
    }
    this.refreshData()
  },

  methods: {
    clearSearch() {
      this.searchTitle = 'Search'
      this.projectFilter.attributes = []
      this.showSearchTile = true
      this.refreshData()
    },
    updateProjectOrderingFilter(filterName) {
      if (this.projectFilter.ordering === filterName) {
        this.projectFilter.ordering = null
      } else {
        this.projectFilter.ordering = filterName
      }
      this.refreshData()
    },
    updateProjectAttributeFilter(attributeId) {
      // If they're clicking a selected attribute, then clear it
      if (this.projectFilter.attributes.includes(attributeId)) {
        const newAttributes = this.projectFilter.attributes.filter(attr => attr !== attributeId)
        this.projectFilter.attributes = newAttributes
      } else {
        this.projectFilter.attributes.push(attributeId)
      }
      this.refreshData()
    },
    toggleInterests() {
      // Toggle the interest button to it's opposite
      this.showInterest = !this.showInterest
      // In all cases, toggle the show location button to false
      // this.showLocation = null
      // Clear all assigned attributes
      // this.projectFilter.attributes = null
    },
    toggleLocations() {
      // Toggle the location button to it's opposite
      this.showLocation = !this.showLocation
      // In all cases, toggle the show interests button to false
      // this.showInterest = false
      // Clear all assigned attributes
      // this.projectFilter.attributes = null
    },
    scrollToTop() {
      let element = document.getElementById('search-tile')
      element.scrollIntoView({ behavior: 'smooth' })
    },
    refreshData(page = null) {
      // Facebook Pixel tracking code
      fbq('track', 'Search')

      this.dataLoaded = false
      let filtersWithPageCount = { ...this.projectFilter }
      if (page) {
        filtersWithPageCount = { ...this.projectFilter, page: page }
      }
      let projectPromise = Project.api.list({ filters: filtersWithPageCount }).then(data => {
        this.paginationDetails = getPaginationDataFromResponse(data)
        this.projects = data.results
      })
      let attributePromise = Attribute.api.list({ filters: this.attributeFilter }).then(data => {
        this.attributes = data.results
      })
      Promise.all([projectPromise, attributePromise])
        .then(() => {
          this.dataLoaded = true
        })
        .catch(() => (this.dataLoaded = true))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/layout';
@import '../styles/forms';
@import '../styles/mixins/buttons';

.search-button {
  @include base-button-medium();
  @include white-background();
}

.search-button-wrapper {
  width: 100%;
  text-align: center;
}

.filter-button {
  @include base-button-medium();
  @include white-background();
}

.filter-button--selected {
  @include base-button-medium();
  @include orange-background();
  margin: 0.75rem;
}

.scroll-button {
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: $secondary;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
}

.projects {
  display: flex;
  justify-content: center;
}
</style>
